export default "__VITE_ASSET__220aceaa__"